import React, { useState } from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { FaArrowLeft, FaCreditCard, FaPlus, FaEdit, FaTrash, FaPaypal } from 'react-icons/fa';

const Container = styled.div`
  padding: 1rem;
`;

const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: var(--text-primary);
  font-size: 16px;
  cursor: pointer;
  padding: 0.5rem 0;
  margin-bottom: 1rem;

  svg {
    font-size: 20px;
  }
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

const Title = styled.h1`
  font-size: 24px;
  color: var(--text-primary);
  margin: 0;
`;

const AddButton = styled.button`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background-color: var(--primary-color);
  color: white;
  border: none;
  border-radius: 5px;
  padding: 0.5rem 1rem;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: var(--primary-color-dark);
  }

  svg {
    font-size: 16px;
  }
`;

const PaymentList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const PaymentCard = styled.div`
  background-color: var(--bg-secondary);
  border-radius: 10px;
  padding: 1.5rem;
  position: relative;
`;

const PaymentType = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 0.5rem;

  svg {
    font-size: 20px;
    color: var(--primary-color);
  }
`;

const PaymentInfo = styled.div`
  font-size: 14px;
  color: var(--text-secondary);
`;

const DefaultBadge = styled.span`
  background-color: var(--primary-color);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 12px;
  font-size: 12px;
  margin-left: 0.5rem;
`;

const ActionButtons = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
  display: flex;
  gap: 0.5rem;
`;

const ActionButton = styled.button`
  background: none;
  border: none;
  color: var(--text-secondary);
  cursor: pointer;
  padding: 0.25rem;
  transition: color 0.2s;

  &:hover {
    color: var(--primary-color);
  }

  svg {
    font-size: 16px;
  }
`;

const PaymentMethods: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [paymentMethods] = useState([
    { id: 1, type: 'Visa', last4: '4567', isDefault: true },
    { id: 2, type: 'PayPal', email: 'thomas.d@example.com', isDefault: false },
  ]);

  const handleEdit = (id: number) => {
    // TODO: Implement edit logic
    console.log('Editing payment method:', id);
  };

  const handleDelete = (id: number) => {
    // TODO: Implement delete logic
    console.log('Deleting payment method:', id);
  };

  const handleAdd = () => {
    // TODO: Implement add logic
    console.log('Adding new payment method');
  };

  return (
    <Container>
      <BackButton onClick={() => navigate('/profile')}>
        <FaArrowLeft />
        {t('common.back')}
      </BackButton>

      <Header>
        <Title>{t('profile.paymentMethods')}</Title>
        <AddButton onClick={handleAdd}>
          <FaPlus />
          {t('profile.addPaymentMethod')}
        </AddButton>
      </Header>

      <PaymentList>
        {paymentMethods.map(method => (
          <PaymentCard key={method.id}>
            <PaymentType>
              {method.type === 'PayPal' ? <FaPaypal /> : <FaCreditCard />}
              {method.type}
              {method.isDefault && <DefaultBadge>{t('profile.default')}</DefaultBadge>}
            </PaymentType>
            <PaymentInfo>
              {method.last4 ? `•••• ${method.last4}` : method.email}
            </PaymentInfo>
            <ActionButtons>
              <ActionButton onClick={() => handleEdit(method.id)}>
                <FaEdit />
              </ActionButton>
              <ActionButton onClick={() => handleDelete(method.id)}>
                <FaTrash />
              </ActionButton>
            </ActionButtons>
          </PaymentCard>
        ))}
      </PaymentList>
    </Container>
  );
};

export default PaymentMethods; 